import queryString from 'query-string';

import { getConfig } from '../config/configuration';
import type { HpDispatchFunction } from './actionTypes';
import { fetchResolver } from './fetchResolver';
import { ErrorMap } from 'interfaces/errorTypes';
import { PolicyDetail } from 'interfaces/customerDataTypes';
import { signOutAction } from './signOutAction';
import { sendAuditEvent, trackPolicyViewsRum } from 'utils';
import { AUDIT_TYPE } from 'interfaces/auditTypes';

export interface CustomerPolicyDetailsPayload {
  policyDetailsId: string;
  historyId: number;
  policyNumber: string;
  username: string;
  isAgent: boolean;
}

export interface CustomerPolicyResponseData {
  policy: PolicyDetail;
  success: boolean;
}

export interface CustomerPolicyDetailsSuccessPayload {
  policyDetail: PolicyDetail;
  policyDetailsId: string;
  historyId: number;
}

export function getCustomerPolicyAction(payload: CustomerPolicyDetailsPayload) {
  return (dispatch: HpDispatchFunction<ErrorMap | CustomerPolicyDetailsSuccessPayload>): Promise<void> | undefined => {
    dispatch({ type: 'CUSTOMER_POLICY_DETAILS_LOADING' });
    const { websiteEndpoint } = getConfig();
    const { policyDetailsId, historyId } = payload;
    const queryText = queryString.stringify({ policyDetailsId, historyId });
    const url = `${websiteEndpoint}/api/customer/policy?${queryText}`;

    return fetchResolver<any>({
      options: { url, method: 'GET', description: `Get customer policy details` },
      dispatch,
      successAction: (response) => {
        const { policyNumber } = payload;
        sendAuditEvent({
          activityId: AUDIT_TYPE.VIEW_POLICY,
          historyId,
          policyDetailsId,
          policyNumber
        });
        trackPolicyViewsRum(policyDetailsId, policyNumber);
        dispatch({
          type: 'CUSTOMER_POLICY_DETAILS_SUCCESS',
          payload: {
            policyDetail: response,
            policyDetailsId,
            historyId
          }
        });
      },
      failedAction: (err) => {
        dispatch({ type: 'CUSTOMER_POLICY_DETAILS_ERROR', payload: err.message });
        // @ts-expect-error dispatching an action creator rather than an action
        dispatch(signOutAction());
      }
    });
  };
}
